import LicenseDetailsPlan from './LicenseDetailsPlan';

export default LicenseDetailsPlan;
